<template>
<div class="page documents">
  <h1>Mijn documenten</h1>
</div>
</template>

<script>
export default {
name: "Documents"
}
</script>
